<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li><a href="https://episcloud.com">Trang chủ</a></li>
                <li>Điêu khoản</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/blog.png" alt="Welcome banner image">
              <img src="../assets/images/info-1.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/board.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-30" class="full-width-content post-30 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="30" class="elementor elementor-30"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-9af42a3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="9af42a3" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c5674a6"
                        data-id="c5674a6" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-e00349e elementor-widget elementor-widget-xs-heading"
                              data-id="e00349e" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Các điều khoản của chúng tôi</h3>
                                  <h2 class="heading-title">CÁC ĐIỀU KHOẢN <span>DỊCH VỤ</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-7337b23 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7337b23" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8cb6da2"
                        data-id="8cb6da2" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-77c09c1 elementor-widget elementor-widget-heading"
                              data-id="77c09c1" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Điều khoản tài khoản</h2>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-8e22874 elementor-widget elementor-widget-text-editor"
                              data-id="8e22874" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <ol class="order-list">
                                    <li>Bạn phải từ 18 tuổi trở lên hoặc ít nhất là độ tuổi trưởng thành trong khu vực tài phán nơi bạn cư trú hoặc nơi bạn sử dụng Dịch vụ này.
                                    </li>
                                    <li>Để truy cập và sử dụng Dịch vụ, bạn phải đăng ký tài khoản Cloud Episp ("Tài khoản") bằng cách cung cấp tên hợp pháp đầy đủ, địa chỉ hiện tại, số điện thoại, địa chỉ email hợp lệ và bất kỳ thông tin nào khác được chỉ định theo yêu cầu. Tập CLOUD có thể từ chối ứng dụng của bạn cho một tài khoản hoặc hủy một tài khoản hiện có, vì bất kỳ lý do nào, theo quyết định riêng của chúng tôi.
                                    </li>
                                    <li>Bạn xác nhận rằng EPIS Cloud sẽ sử dụng địa chỉ email bạn cung cấp làm phương thức liên lạc chính.
                                    </li>
                                    <li>Bạn chịu trách nhiệm bảo vệ mật khẩu của bạn an toàn. EPIS Cloud không thể và sẽ không chịu trách nhiệm đối với bất kỳ tổn thất hoặc thiệt hại nào do bạn không duy trì tính bảo mật cho Tài khoản và mật khẩu của mình.
                                    </li>
                                    <li>Bạn chịu trách nhiệm cho tất cả các hoạt động và nội dung như hình ảnh, hình ảnh, video, đồ họa, nội dung bằng văn bản, tệp âm thanh, mã, thông tin hoặc dữ liệu được tải lên, thu thập, tạo, lưu trữ, hiển thị, phân phối, truyền hoặc trưng bày trên hoặc liên quan Tài khoản của bạn ("Tài liệu").
                                    </li>
                                    <li>Việc vi phạm hoặc vi phạm bất kỳ điều khoản nào trong Điều khoản dịch vụ, bao gồm cả AUP, theo quyết định riêng của EPIS Cloud sẽ dẫn đến việc dịch vụ của bạn bị chấm dứt ngay lập tức.
                                    </li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Kích hoạt tài khoản</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <ol class="order-list">
                                    <li>Theo mục 2.1.2, người đăng ký dịch vụ sẽ là bên ký kết ("chủ tài khoản") cho các mục đích của các điều khoản dịch vụ của chúng tôi và sẽ là người được ủy quyền sử dụng bất kỳ tài khoản tương ứng nào mà chúng tôi có thể cung cấp cho Chủ sở hữu tài khoản liên quan đến dịch vụ.
                                    </li>
                                    <li>Nếu bạn đang đăng ký dịch vụ thay mặt cho chủ nhân của bạn, chủ nhân của bạn sẽ là chủ tài khoản. Nếu bạn đang đăng ký dịch vụ thay mặt cho chủ nhân của bạn, thì bạn tuyên bố và bảo đảm rằng bạn có thẩm quyền ràng buộc chủ nhân của bạn với các điều khoản dịch vụ của chúng tôi.
                                    </li>
                                    <li>Sau khi hoàn thành đăng ký dịch vụ, EPISH CLOUD sẽ thay mặt bạn tạo tài khoản thanh toán PayPal Express, sử dụng địa chỉ email của bạn. Tùy thuộc vào vị trí của bạn, Epise Cloud cũng có thể thay mặt bạn có thể tạo một tài khoản thanh toán đám mây.
                                    </li>
                                    <li>Bạn thừa nhận rằng thanh toán PayPal Express và/hoặc Episp Cloud sẽ là cổng thanh toán mặc định của bạn và đó là trách nhiệm duy nhất của bạn với tư cách là chủ sở hữu tài khoản để kích hoạt và duy trì các tài khoản này. Nếu bạn không muốn giữ một trong hai tài khoản thanh toán hoạt động, bạn có trách nhiệm vô hiệu hóa chúng. Để tránh nghi ngờ, thanh toán PayPal Express là dịch vụ của bên thứ ba, như được định nghĩa trong Phần 15 của các Điều khoản dịch vụ này.
                                    </li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-08593eb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="08593eb" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6e33099 animated-slow animated fadeInLeft"
                        data-id="6e33099" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-eca8eaa elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="eca8eaa" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b49de96 animated-slow animated fadeInRight"
                        data-id="b49de96" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-df6f32d elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="df6f32d" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-568013b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="568013b" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-82d5282"
                        data-id="82d5282" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7c339b6 elementor-widget elementor-widget-spacer"
                              data-id="7c339b6" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Term'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Term.vue